<template lang="html">
    <form @submit.prevent="onSubmit()" autocomplete="off" class="form" :class="{ 'loading': isSending }">
        <div class="form__items">
            <div class="form-item">
                <label class="form-item__label">Номер счета</label>
                <div class="default-input">
                    <input
                        v-model="formData.orderId"
                        type="text"
                        inputmode="numeric"
                        name="order-id"
                    >
                </div>
            </div>
            <div class="form-item">
                <label class="form-item__label">Сумма по счету</label>
                <div class="default-input">
                    <input
                        v-model="formData.price"
                        type="text"
                        inputmode="numeric"
                        name="price"
                    >
                </div>
            </div>
        </div>
        <div class="form__bottom">
            <button type="submit" class="btn">
                Оплатить
            </button>
        </div>
    </form>
</template>

<script>
import {reactive, ref} from 'vue';
import {requestSendPaymentSberWidget} from "@/api";

export default {
    name : 'SberWidgetForm',
    setup () {
        const formData = reactive({
            orderId: '',
            price: '',
        })
        const container = document.getElementById("sber-widget");
        const widgetId = "kvk";
        const isSending = ref(false);

        async function onSubmit() {
            isSending.value = true;
            try {
                const response = await requestSendPaymentSberWidget(formData);
                if (response.message) alert(response.message);
                const data = response.data;
                if (data) {
                    window.SberWidgetsSDK.create({
                        widgetId,
                        key: data.key,
                        partnerId: data.partnerId,
                        container,
                        orderData: data.orderData,
                    });
                }
            } catch (error) {
                console.error(error);
            } finally {
                isSending.value = false;
            }
        }
        return {
            onSubmit,
            formData,
            isSending,
        };
    }
}
</script>
